import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal } from '@beef/ui-kit';
// actions
import { BACK_CALL_POPUP_IS_SHOWN } from '@fttb/common/constants';
import { getOrderTariffTexts } from "../../store/selectors/orderTariffCommon";
import { handleOrderStepsSecondProgress } from "../../store/actions/handleOrderSecondaryStepsProgress";
import { backButtonClickWithYm } from "../../store/actions/withAnalytics";
import { resetOrderTariffData } from "../../store/actions/resetOrderTariffData";
import { handleOrderStepsProgress } from "../../store/actions/handleOrderStepsProgress";
// selectors
import { getFlagIsHeaderConfigRender } from "../../store/selectors/modal";
// components
import { ModalActionBar } from "./ModalActionBar";
var OrderTariffControl = function OrderTariffControl(_ref) {
  var headerBarTitle = _ref.headerBarTitle,
    isHeaderConfig = _ref.isHeaderConfig,
    headerBarClick = _ref.headerBarClick,
    isOpen = _ref.isOpen,
    children = _ref.children,
    handleClose = _ref.handleClose,
    handleClick = _ref.handleClick,
    handleSecondaryButtonClick = _ref.handleSecondaryButtonClick;
  useEffect(function () {
    if (isOpen) sessionStorage.setItem(BACK_CALL_POPUP_IS_SHOWN, '1');
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(Modal, {
    actionBar:
    /*#__PURE__*/
    // @ts-expect-error onClick is AsyncThunk
    React.createElement(ModalActionBar, {
      onClick: handleClick,
      onSecondaryButtonClick: handleSecondaryButtonClick
    }),
    headerBarConfig: isHeaderConfig ? {
      backButtonText: headerBarTitle,
      backButtonClick: headerBarClick
    } : undefined,
    isOpen: isOpen,
    onClose: handleClose,
    size: "m",
    "data-t-id": "components-OrderTariffControl"
  }, children);
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isHeaderConfig: getFlagIsHeaderConfigRender(state),
    headerBarTitle: getOrderTariffTexts(state).headerBarTitle
  };
};
var mapDispatchToProps = {
  headerBarClick: backButtonClickWithYm,
  handleClose: resetOrderTariffData,
  handleClick: handleOrderStepsProgress,
  handleSecondaryButtonClick: handleOrderStepsSecondProgress
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var OrderTariffModalWithStore = connector(OrderTariffControl);
export { OrderTariffModalWithStore as OrderTariffControl };